import { Button } from "@mui/material";
import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";
import { useNavigate } from "react-router-dom";
import { updateStudent } from "../../redux/redux";

const Logout = () => {
  const navigate = useNavigate();

  const handleClickLogout = () => {
    localStorage.removeItem("student");
    updateStudent({});
    navigate("/", {
      replace: true,
    });
  };

  return (
    <Button
      onClick={handleClickLogout}
      variant="contained"
      color="error"
      endIcon={<LogoutTwoToneIcon />}
      size="small"
    >
      Logout
    </Button>
  );
};

export default Logout;
